import {classNames} from "../../../util/util-helpers";
import React, {useEffect, useRef} from "react";

export default function FieldTimeFocusElement({
    innerRef,
    dropdownRef,
    hoursInputRef,
    inputsContainerRef,
    minutesInputRef,
    periodInputRef,
    hideDropdown,
    onTabForward,
    onArrowUpDown,
    isWholeFieldFocused,
}) {
    const hideDropdownRef = useRef(hideDropdown);
    hideDropdownRef.current = hideDropdown;

    function handleKeyDown(e) {
        if (e.key === 'Tab' && !e.shiftKey) {
            e.preventDefault();
            onTabForward();
            hideDropdown();
        }

        if (e.key === 'Tab' && e.shiftKey) {
            hideDropdown();
        }

        if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter') {
            e.preventDefault();
            onArrowUpDown();
        }
    }

    useEffect(() => {
        const outsideClick = (event) => {
            if (
                !inputsContainerRef.current?.contains(event.target) &&
                !dropdownRef.current?.contains(event.target)
            ) {
                hideDropdownRef.current();
            }
        };

        document.addEventListener("click", outsideClick, false);

        return () => document.removeEventListener("click", outsideClick, false);
    }, []);

    return (
        <button
            ref={innerRef}
            onKeyDown={handleKeyDown}
            onFocus={() => {
                if (!isWholeFieldFocused) {
                    hoursInputRef.current.focus();
                }
            }}
            className={classNames("absolute opacity-0 inset-0 -z-10")}
        />
    );
}
